module.exports = __webpack_public_path__ + "img/shenhe.f578a4bd.png";